export const accordion = {
  colorScheme: {
    light: {
      header: {
        background: '#c5c5c5ff',
        color: 'black',
        borderColor: '#5B5F69',
        active: {
          background: '#c5c5c5ff',
          color: 'black',
          borderColor: '#5B5F69',
          hover: {
            background: '#c5c5c5ff',
            color: 'black',
          },
        },
        hover: {
          background: '#c5c5c5ff',
          color: 'black',
        },
      },
      content: {
        background: '#ebeceeff',
        color: 'black',
        borderColor: '#5B5F69',
      },
    },
    dark: {
      header: {
        background: '#46495aff',
        color: 'white',
        borderColor: '#5B5F69',
        active: {
          background: '#46495aff',
          color: 'white',
          borderColor: '#5B5F69',
          hover: {
            background: '#46495aff',
            color: '{text.color}',
          },
        },
        hover: {
          background: '#46495aff',
          color: '{text.color}',
        },
      },
      content: {
        background: '#393d4d',
        color: 'white',
        borderColor: '#5B5F69',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
.p-accordionpanel-active {
margin: 0;
}
`,
};
